import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import PrincipalActionButton from './PrincipalActionButton';
import SecondaryActionButtons from './SecondaryActionButtons';
import './styles.scss';

const ActionButtons = ({ data }) => {
    const principalBtns = useMemo(() => data.filter((item) => item.principal), [data]);
    const secondaryBtns = useMemo(() => data.filter((item) => !item.principal), [data]);

    return (
        <div className="action-buttons">
            {principalBtns.map((btn) => (
                <PrincipalActionButton {...btn} key={btn.id} />
            ))}
            <SecondaryActionButtons data={secondaryBtns} />
        </div>
    );
};

ActionButtons.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            action: PropTypes.func,
            icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
            label: PropTypes.string,
            principal: PropTypes.bool,
        }),
    ).isRequired,
};

export default ActionButtons;
